function srTpl(str, token, value) {
    if (str == null || str === '') return '';
    return String(str).split(token).join(String(value));
}

function parseShippingRatesI18n() {
    const defaults = {
        consulting: 'Checking…',
        submit_ok: 'OK',
        err_cep_length: 'Postal code must be 8 digits. Please check and try again.',
        err_cep_invalid: 'Invalid postal code. Please check the number and try again.',
        err_product_data: "We couldn't load product data to calculate shipping.",
        err_quote_failed: "We couldn't fetch shipping rates. Please try again.",
        err_no_rates: 'No shipping options available for this postal code.',
        err_no_methods: 'No shipping methods available.',
        err_generic: 'Could not get shipping rates.',
        err_connection: 'Connection error. Check your internet and try again.',
        delivery_single: 'Delivered on __DAY__',
        delivery_range: 'Delivered between __MIN__ and __MAX__',
        delivery_one_day: 'Up to 1 business day',
        delivery_n_days: 'Up to __N__ business days',
        checkout_availability: 'See availability at checkout',
        free: 'FREE',
        shipping_fallback: 'Shipping',
        scheduled_title: 'Scheduled delivery',
        scheduled_desc: 'Check availability at checkout',
        geo_no_postcode: 'No postal code found for this location.',
        geo_cep_invalid: 'Invalid postal code from your location.',
        geo_unavailable: 'Geolocation is not available in your browser.',
        geo_fetching: 'Getting location…',
        geo_reverse_failed: 'Could not get a postal code from your location. Please enter it manually.',
        geo_permission_denied: 'Permission denied. Enable location in your browser settings.',
        geo_position_unavailable: 'Location is unavailable right now.',
        geo_timeout: 'Timed out while getting location.',
        geo_generic: 'Could not get your location.',
        money_locale: 'en',
        money_currency: 'BRL',
        date_locale: 'en',
        zip_codes_with_pickup_points_title: 'Pickup at Madesa',
        zip_codes_with_pickup_points_description: 'Check available pickup times',
    };
    const el = document.getElementById('shipping-rates-i18n');
    if (!el || !String(el.textContent || '').trim()) {
        return defaults;
    }
    try {
        const parsed = /** @type {Record<string, unknown>} */ (JSON.parse(el.textContent));
        /** @type {typeof defaults} */
        const out = Object.assign({}, defaults);
        let pk;
        for (pk in parsed) {
            if (
                Object.prototype.hasOwnProperty.call(parsed, pk) &&
                Object.prototype.hasOwnProperty.call(defaults, pk) &&
                parsed[pk] != null &&
                parsed[pk] !== ''
            ) {
                out[/** @type {keyof typeof defaults} */ (pk)] = String(parsed[pk]);
            }
        }
        return out;
    } catch (e) {
        return defaults;
    }
}

const SR = parseShippingRatesI18n();

if (!customElements.get('shipping-rates')) {
    class ShippingRates extends HTMLElement {
        constructor() {
            super();
            this.form = this.querySelector('[data-form="shipping-rates"]');
            this.ratesList = this.querySelector('[data-shipping-rates]');
            this.zipCode = this.querySelector('[data-zip-code]');
            this.button = this.querySelector('[data-form-show]');
            this.message = this.querySelector('[data-message]');
            this.useLocationButton = this.querySelector('.shipping-rates__use-location');
            this.submitButton = this.form?.querySelector('button[type="submit"]');
            this.place = this.querySelector('[data-shipping-place]');
            this.placeText = this.querySelector('[data-shipping-location]');
            this.productData = this.loadProductData();
            this.percentage = Number(this.getAttribute('data-percentage') || 0);
            this.currency = this.getAttribute('data-currency') || 'BRL';
            this.freeText = this.getAttribute('data-free-text') || "";
            this.init();
        }

        loadProductData() {
            const jsonEl = this.querySelector('script[data-shipping-product]');
            if (!jsonEl) return null;
            try {
                return JSON.parse(jsonEl.textContent);
            } catch (e) {
                console.error('Error parsing product data:', e);
                return null;
            }
        }

        getSelectedVariantId() {
            const input = document.querySelector('input[name="id"]');
            return input ? input.value : null;
        }

        buildProductPayload() {
            if (!this.productData) return null;
            const variantId = this.getSelectedVariantId();
            const variantData = this.productData.variants?.[variantId];
            if (!variantData) return null;

            return {
                weight: variantData.weight || 0,
                cost_of_goods: variantData.cost_of_goods || 0,
                width: this.productData.width || 0,
                height: this.productData.height || 0,
                length: this.productData.length || 0,
                quantity: 1,
                sku_id: variantData.sku_id || '',
            };
        }

        getSavedAddress() {
            try {
                const saved = localStorage.getItem('madesa-address');
                return saved ? JSON.parse(saved) : null;
            } catch (error) {
                return null;
            }
        }

        normalizeCep(value) {
            return String(value || '').replace(/\D/g, '');
        }

        formatCep(value) {
            const digits = this.normalizeCep(value);
            if (digits.length !== 8) return value;
            return `${digits.slice(0, 5)}-${digits.slice(5)}`;
        }

        syncSavedAddress(data) {
            localStorage.setItem('madesa-address', JSON.stringify(data));
            document.dispatchEvent(new CustomEvent('cep:updated', { detail: data }));
        }

        init() {
            this.form.addEventListener('submit', (event) => this.submit(event));
            this.form.querySelector('#zip-code').addEventListener('input', (event) => this.maskZipCode(event));
            if (this.button) this.button.addEventListener('click', () => this.reset());
            if (this.useLocationButton) {
                this.useLocationButton.addEventListener('click', () => this.useGeolocation());
            }

            document.addEventListener('cep:updated', (e) => {
                if (e.detail?.cep) {
                    const input = this.form.querySelector('#zip-code');
                    if (input) input.value = e.detail.cep;
                }
            });

            this.prefillAndAutoCalculate();
        }

        prefillAndAutoCalculate() {
            const input = this.form.querySelector('#zip-code');
            if (!input) return;

            const savedAddress = this.getSavedAddress();
            const rawCep = savedAddress?.cep || savedAddress?.zip || savedAddress?.postalCode;
            if (!rawCep) return;

            const cleanCep = this.normalizeCep(rawCep);
            if (cleanCep.length !== 8) return;

            input.value = this.formatCep(cleanCep);

            if (savedAddress.city && savedAddress.state) {
                this.setLocationLabel(savedAddress.city, savedAddress.state);
            }

            setTimeout(() => {
                const ev = { preventDefault() {} };
                this.submit(ev);
            }, 200);
        }

        reset() {
            this.showElement(this.form);
            this.hideElement(this.ratesList);
            this.hideElement(this.zipCode);
            this.hideElement(this.place);
            this.hideElement(this.message);
        }

        formatMoney(cents) {
            const loc = SR.money_locale || 'pt-BR';
            const cur = SR.money_currency || 'BRL';
            return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(
                (Number(cents) || 0) / 100,
            );
        }

        async submit(event) {
            event.preventDefault();
            const button = this.form.querySelector('button[type="submit"]');
            button.disabled = true;
            button.textContent = SR.consulting;
            this.hideElement(this.message);
            this.hideElement(this.ratesList);
            this.hideElement(this.place);

            try {
                const zip = this.form.querySelector('input[name="zip-code"]').value.replace(/\D/g, '');

                if (zip.length !== 8) {
                    throw new Error(SR.err_cep_length);
                }

                const savedAddress = this.getSavedAddress();
                const savedCep = this.normalizeCep(savedAddress?.cep);

                let city, state;
                if (savedAddress && savedCep === zip) {
                    city = savedAddress.city;
                    state = savedAddress.state;
                } else {
                    const response = await fetch(`https://brasilapi.com.br/api/cep/v1/${zip}`);
                    if (!response.ok) throw new Error(SR.err_cep_invalid);
                    const data = await response.json();
                    city = data.city;
                    state = data.state;

                    this.syncSavedAddress({
                        cep: this.formatCep(zip),
                        city: city || '',
                        state: state || '',
                        neighborhood: data.neighborhood || '',
                        street: data.street || '',
                    });
                }

                const product = this.buildProductPayload();
                if (!product) {
                    throw new Error(SR.err_product_data);
                }

                const rates = await this.fetchShippingRates(zip, [product]);
                const zipCodesWithPickupPoints = window.MADESA_PICKUP_ZIP_CODES || '';


                function isZipCodeInRange(zipCode) {
                    const zipCodeNumber = Number(String(zipCode).replace(/\D/g, ''));

                    return zipCodesWithPickupPoints
                        .split(',')
                        .map(range => range.trim())
                        .filter(Boolean)
                        .some(range => {
                            const [start, end] = range
                                .split('-')
                                .map(value => Number(value.trim()));

                            if (isNaN(start) || isNaN(end)) {
                                return false;
                            }

                            return zipCodeNumber >= start && zipCodeNumber <= end;
                        });
                }

                const showPickupOption = isZipCodeInRange(zip);

                this.displayShippingRates(rates, showPickupOption);
                this.setLocationLabel(city, state);
            } catch (error) {
                console.warn(error);
                let errorMessage = error.message || SR.err_generic;
                if (errorMessage === 'Failed to fetch') {
                    errorMessage = SR.err_connection;
                }
                this.displayError(errorMessage);
            } finally {
                button.disabled = false;
                button.textContent = SR.submit_ok;
            }
        }

        async fetchShippingRates(cep, products) {
            const response = await fetch('https://contingencia.checkstore.com.br/quote-madesa', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    origin_zip_code: '95765000',
                    destination_zip_code: cep,
                    products,
                    additional_information: {
                        sales_channel: 'Shopify',
                    },
                }),
            });

            if (!response.ok) throw new Error(SR.err_quote_failed);

            const data = await response.json();
            if (!data.rates?.length) throw new Error(SR.err_no_rates);

            return data.rates;
        }

        displayShippingRates(rates, showPickupOption) {
            if (!rates.length) throw new Error(SR.err_no_methods);
            this.ratesList.innerHTML = rates.map(rate => {
                let deadlineText = '';
                if (rate.min_delivery_date && rate.max_delivery_date) {
                    const minDay = this.formatDay(rate.min_delivery_date);
                    const maxDay = this.formatDay(rate.max_delivery_date);
                    deadlineText = minDay === maxDay
                        ? srTpl(SR.delivery_single, '__DAY__', minDay)
                        : srTpl(srTpl(SR.delivery_range, '__MIN__', minDay), '__MAX__', maxDay);
                } else {
                    const days = rate.business_days || rate.days_estimated;
                    deadlineText = days
                        ? (days === 1 ? SR.delivery_one_day : srTpl(SR.delivery_n_days, '__N__', days))
                        : SR.checkout_availability;
                }
                const priceCents = rate.total_price || 0;
                const newPriceCents = priceCents / 100
                const providerCents = rate.provider_shipping_cost || 0;

                const priceCentsIncreased = Math.round((this.percentage / 100) * newPriceCents) + newPriceCents;
                const isPaid = priceCents > 0;
                const storeConfigs = {
                'BRL': { locale: 'pt-BR', currency: 'BRL' },
                'ARS': { locale: 'es-AR', currency: 'ARS' },
                'MXN': { locale: 'es-MX', currency: 'MXN' }
                };

                const currentCountry = this.currency;
                const { locale, currency } = storeConfigs[currentCountry] || storeConfigs['BR'];
                const formatedCents = new Intl.NumberFormat(locale, {style: 'currency', currency: currency}).format(newPriceCents)
                const formatedIncreased = new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(priceCentsIncreased)
                const formatedProvider = new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(providerCents)

                const paidText =  `<span class="shipping-rate__price--old">${formatedIncreased}</span> ${formatedCents}`;
                const freeText =  `<span class="shipping-rate__price--old">${formatedProvider}</span> ${this.freeText}`;
                const priceText = isPaid
                    ? paidText
                    : freeText;

                    return `
                <li class="shipping-rate">
                    <div class="shipping-rate__info">
                        <span class="shipping-rate__title">${rate.service_name || SR.shipping_fallback}</span>
                        <span class="shipping-rate__desc">${deadlineText}</span>
                    </div>
                    <div class="shipping-rate__price${isPaid ? '' : ' is-free'}">${priceText}</div>
                </li>
                `;
                })
                .join('');

            const firstRate = rates[0];
            const agendadaCents = firstRate?.total_price || 0;
            const agendadaPaid = agendadaCents > 0;
            const agendadaPrice = agendadaPaid ? this.formatMoney(agendadaCents) : SR.free;

            this.ratesList.innerHTML += `
                <li class="shipping-rate">
                    <div class="shipping-rate__info">
                        <span class="shipping-rate__title">${SR.scheduled_title}</span>
                        <span class="shipping-rate__desc">${SR.scheduled_desc}</span>
                    </div>
                    <div class="shipping-rate__price${agendadaPaid ? '' : ' is-free'}">${agendadaPrice}</div>
                </li>`;
            

            if (showPickupOption) {
                this.ratesList.innerHTML += `
                    <li class="shipping-rate">
                        <div class="shipping-rate__info">
                            <span class="shipping-rate__title">Retirada na Madesa</span>
                            <span class="shipping-rate__desc">Verifique os horários disponíveis para retirada</span>
                        </div>
                        <div class="shipping-rate__price is-free">${SR.free}</div>
                    </li>`;
            }


            
            this.showElement(this.ratesList);
        }

        /**
         * @param {string} dateString
         * @param {string} [locale]
         */
        formatDay(dateString, locale) {
            const loc = locale || SR.date_locale || SR.money_locale || 'pt-BR';
            try {
                if (dateString?.match(/^\d{4}-\d{2}-\d{2}$/)) {
                    const [year, month, day] = dateString.split('-');
                    const date = new Date(year, month - 1, day);
                    return new Intl.DateTimeFormat(loc, { day: '2-digit', month: '2-digit' }).format(date);
                }
                return new Intl.DateTimeFormat(loc, { day: '2-digit', month: '2-digit' }).format(
                    new Date(dateString),
                );
            } catch (e) {
                return dateString;
            }
        }

        maskZipCode(e) {
            let v = e.target.value.replace(/\D/g, '');
            if (v.length > 5) v = v.replace(/^(\d{5})(\d{1,3}).*/, '$1-$2');
            e.target.value = v;
        }

        displayError(msg) {
            this.message.textContent = msg;
            this.message.style.color = '#3e3e3d';
            this.showElement(this.message);
        }

        setLocationLabel(city, state) {
            if (!this.place || !this.placeText) return;
            if (!city || !state) {
                this.hideElement(this.place);
                return;
            }

            this.placeText.textContent = `${city}, ${state}`;
            this.showElement(this.place);
        }

        geoErrorMessage(errorCode) {
            if (errorCode === 1) return SR.geo_permission_denied;
            if (errorCode === 2) return SR.geo_position_unavailable;
            if (errorCode === 3) return SR.geo_timeout;
            return SR.geo_generic;
        }

        async useGeolocation() {
            if (!navigator.geolocation) {
                this.displayError(SR.geo_unavailable);
                return;
            }

            const input = this.form.querySelector('#zip-code');
            if (!input) return;

            this.useLocationButton.disabled = true;
            const originalText = this.useLocationButton.textContent;
            this.useLocationButton.textContent = SR.geo_fetching;
            this.setSubmitLoading(true);

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;

                    fetch(
                        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&addressdetails=1`,
                        { headers: { 'User-Agent': 'MadesaStore/1.0' } },
                    )
                        .then((response) => response.json())
                        .then((data) => {
                            const postcode = data.address?.postcode;
                            if (!postcode) throw new Error(SR.geo_no_postcode);

                            const cleanCEP = postcode.replace(/\D/g, '');
                            if (cleanCEP.length !== 8) {
                                throw new Error(SR.geo_cep_invalid);
                            }

                            const formattedCEP = `${cleanCEP.slice(0, 5)}-${cleanCEP.slice(5)}`;
                            input.value = formattedCEP;
                            input.dispatchEvent(new Event('input', { bubbles: true }));
                            this.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
                        })
                        .catch((error) => {
                            console.warn('Erro no reverse geocoding:', error);
                            const msg =
                                error instanceof Error && error.message
                                    ? error.message
                                    : SR.geo_reverse_failed;
                            this.displayError(msg);
                        })
                        .finally(() => {
                            this.useLocationButton.disabled = false;
                            this.useLocationButton.textContent = originalText;
                            this.setSubmitLoading(false);
                        });
                },
                (error) => {
                    console.warn('Erro ao obter localização:', error);
                    const errorMessage = this.geoErrorMessage(error && error.code);
                    this.displayError(errorMessage);
                    this.useLocationButton.disabled = false;
                    this.useLocationButton.textContent = originalText;
                    this.setSubmitLoading(false);
                },
            );
        }

        setSubmitLoading(isLoading) {
            if (!this.submitButton) return;
            if (isLoading) {
                this.submitButton.disabled = true;
                this.submitButton.classList.add('is-loading');
                this.submitButton.dataset.originalText = this.submitButton.textContent;
                this.submitButton.textContent = SR.submit_ok;
                return;
            }

            this.submitButton.disabled = false;
            this.submitButton.classList.remove('is-loading');
            if (this.submitButton.dataset.originalText) {
                this.submitButton.textContent = this.submitButton.dataset.originalText;
                delete this.submitButton.dataset.originalText;
            }
        }

        showElement(el) {
            el?.classList.remove('hidden');
        }
        hideElement(el) {
            el?.classList.add('hidden');
        }
    }

    customElements.define('shipping-rates', ShippingRates);
}
